export const sampleKit = {
    fr: "https://www.luminaireauthentik.com/fr/kit-dechantillon",
    en: "https://www.luminaireauthentik.com/kit-dechantillon"
};
export var colorMaterials = {
    default: {
        "canopy": "SAME_EXT",
        "wire": "TWT.W",
        "hardware": "BRR",
        "swivel": "BRR",
        "stem": "WTL",
        "exterior": "WTL",
        "exterior2": "WTL",
        "exterior3": "WTL",
        "interior": "SAME_EXT",
        "terrazzo": "O.WHT",
        "terrazzobase": "O.WHT",
        "glass": "GB-CG",
        "glassint": null,
        "cable": null,
        "hook": "BRR",
        "cablehardware": null,
        "chrome": "CHR.BZG",
        "marbre": "M.WHT",
        "mineral": "MIN.AQL"
    }, curr: {}, prev: {}
};
export var currentBG = { color: "Grey", hex: null };
export var prevBG = { color: "Grey", hex: null };
export var currentPalette = { id: null, code: [] };
export var prevPalette = { id: null, code: [] };

export var currCanopy = { data: {} };
export var prevCanopy = { data: {} };
export var originalCanopy = { data: {} };

export var currStem = { data: {} };
export var originalStem = { data: {} };
export var prevStem = { data: {} };

export var currVariation = { data: {} };
export var originalVariation = { data: {} };
export var prevVariation = { data: {} };

export const sortOrder = [
    'exterior',
    'interior',
    'exterior2',
    'exterior3',
    'terrazzo',
    'chrome',
    'marbre',
    'mineral',
    'glass',
    'glassint',
    'wire',
    'wireLen',
    'stem',
    'stemLen',
    'hardware',
    'canopyType',
    'canopy',
    'cable',
    'cablehardware',
    'hook',
    'swivel',
    'terrazzobase',
]
export const sortOrderProduct = [
    'canopy',
    'hardware',
    'cable',
    'cablehardware',
    'hook',
    'swivel',
    'stem',
    'terrazzobase',
    'wire',
    'exterior',
    'exterior2',
    'exterior3',
    'terrazzo',
    'chrome',
    'marbre',
    'mineral',
    'interior',
    'glass',
    'glassint',
]

export const bgValues = [
    {
        'islandH': "3",
        'islandW': "10",
        'ceilingH': "9",
        'type': 'island'
    },
    {
        'islandH': "2¾",
        'islandW': "6¾",
        'ceilingH': "9½",
        'type': 'table'
    },
    {
        'islandH': "3",
        'islandW': "12",
        'ceilingH': "9",
        'type': 'island'
    },
    {
        'islandH': "3",
        'islandW': "12",
        'ceilingH': "11",
        'type': 'heightOnly'
    },
    {
        'islandH': "3",
        'islandW': "12",
        'ceilingH': "13",
        'type': 'heightOnly'
    }
]

export var productID = { build: null, lampshade: null };

export function lightOrDark(color, reference = '#e8e0d2') {
    function toRGB(c) {
        let r, g, b;
        if (c.match(/^rgb/)) {
            let m = c.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)/);
            r = +m[1]; g = +m[2]; b = +m[3];
        } else {
            c = +("0x" + c.slice(1).replace(c.length < 5 && /./g, '$&$&'));
            r = c >> 16;
            g = (c >> 8) & 255;
            b = c & 255;
        }
        return { r, g, b };
    }

    function hsp({ r, g, b }) {
        return Math.sqrt(
            0.299 * (r * r) +
            0.587 * (g * g) +
            0.114 * (b * b)
        );
    }

    const hspColor = hsp(toRGB(color));
    const hspRef   = hsp(toRGB(reference));

    if (hspColor > hspRef) {
        return 'Light';
    } else if (hspColor < hspRef) {
        return 'Dark';
    } else {
        return 'Light';
    }
}

// Colors 
export const hexToRgb = (hex) => {
    let bigint = parseInt(hex.slice(1), 16);
    let r = (bigint >> 16) & 255;
    let g = (bigint >> 8) & 255;
    let b = bigint & 255;

    return { r, g, b };
};

export const rgbToHsl = ({ r, g, b }) => {
    r /= 255;
    g /= 255;
    b /= 255;

    let max = Math.max(r, g, b);
    let min = Math.min(r, g, b);
    let h, s, l = (max + min) / 2;

    if (max === min) {
        h = s = 0; // achromatic
    } else {
        let d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }

    return { h, s, l };
};

/*export function getGoodName(erpName) {
    var rtn;
    switch (erpName) {
        case 'canopy.couleur':
            rtn = 'canopy';
            break;
        case 'quincaillerie.couleur':
            rtn = 'hardware';
            break;
        case 'fil.couleur':
        case 'fil.torsade.couleur':
            rtn = 'wire';
            break;
        case 'abatjour.couleur.onyx_ext':
        case 'abatjour.couleur.marbre_ext':
            rtn = 'terrazzo';
            break;
        case 'abatjour.couleur_ext':
            rtn = 'exterior';
            break;
        case 'abatjour.couleur_int':
            rtn = 'interior';
            break;
        case 'globe.couleur':
            rtn = 'glassint';
            break;
        case 'globe.fini':
            rtn = 'glass';
            break;
        case 'pivot.couleur':
            rtn = 'swivel';
            break;
        case 'tige.couleur':
            rtn = 'stem';
            break;
        case 'hook.couleur':
            rtn = 'hook';
            break;
        case 'cable.couleur':
            rtn = 'cable';
            break;
        case 'suspension_system.couleur':
            rtn = 'cablehardware';
            break;
    }
    return rtn;
}*/

// OLD
// export let mapERP = {
//     'canopy.couleur': 'canopy',
//     'quincaillerie.couleur': 'hardware',
//     'fil.couleur': 'wire',
//     'fil.torsade.couleur': 'wire',
//     'abatjour.couleur.onyx_ext': 'terrazzo',
//     'abatjour.couleur.marbre_ext': 'marbre',
//     'abatjour.couleur_ext': 'exterior',
//     'abatjour.couleur.ext_haut': 'exterior3',
//     'abatjour.couleur_ext_centre': 'exterior2',
//     'abatjour.couleur.chrome_ext': 'chrome',
//     'abatjour.couleur.mineral_ext': 'mineral',
//     'abatjour.couleur_int': 'interior',
//     'globe.couleur': 'glassint',
//     'glass.couleur': 'glassint',
//     'globe.fini': 'glass',
//     'glass.fini': 'glass',
//     'pivot.couleur': 'swivel',
//     'tige.couleur': 'stem',
//     'hook.couleur': 'hook',
//     'cable.couleur': 'cable',
//     'suspension_system.couleur': 'cablehardware'
// };

//NEW
// export let mapERP = {
//     'Canopi couleur': 'canopy',
//     'Quincaillerie': 'hardware',
//     'Fil Couleur': 'wire',
//     'Couleur Abat-Jour': 'exterior',
//     'Couleur Abat-jour 2': 'exterior2',
//     'Couleur Abat-Jour 3': 'exterior3',
//     'Abat-Jour Couleur INT': 'interior',

//     'Couleur Abat-Jour': 'terrazzo',
//     'Couleur Abat-Jour': 'marbre',
//     'Couleur Abat-Jour': 'chrome',
//     'Couleur Abat-Jour': 'mineral',

//     'Tige Couleur': 'stem',
//     'Quincaillerie divers': 'hook',

//     'globe.couleur': 'glassint',
//     'glass.couleur': 'glassint',
//     'globe.fini': 'glass',
//     'glass.fini': 'glass',


//     // 'Quincaillerie': 'swivel',
//     // 'cable.couleur': 'cable',
//     // 'suspension_system.couleur': 'cablehardware'
// };
//NEW
export let mapERP = {
    'canopy': 'Canopi couleur',
    'hardware': 'Quincaillerie',
    'swivel': ' Couleur Swivel',
    'wire': 'Fil Couleur',
    'exterior': 'Couleur Abat-Jour',
    'exterior2': 'Couleur Abat-jour 2',
    'exterior3': 'Couleur Abat-Jour 3',
    'interior': 'Abat-Jour Couleur INT',
    'glass': 'Verre couleur et fini',
    
    'terrazzo': 'Couleur Stone',
    'marbre': 'Couleur Stone',
    'chrome': 'Couleur Abat-Jour',
    'mineral': 'Couleur Stone',
    
    'stem': 'Tige Couleur',

    'stemLen': 'Tige Longeur',
    'canopyType': 'Canopy Type',
    'wireLen': 'Fil Longueur',
    'hook': 'Quincaillerie divers',
};

export let tmpMtl;

export const isAnyUpper = string => /\p{Lu}/u.test(string)

let oldExt = [
    // "terrazzo",
    // "marbre",
    "chrome",
    // "mineral"
];

export function transformExt(params) {
    // On filtre les valeurs qui sont dans oldExt
    const kept = params.filter(p => oldExt.includes(p));

    // On gère le cas spécial de "exterior"
    let exteriorResult = "exterior";
    if (params.includes("exterior")) {
        let i = 2;
        while (params.includes(`exterior${i}`)) {
            i++;
        }
        exteriorResult = `exterior${i}`;
    }

    // console.log(kept[0], exteriorResult)
    return { ext: exteriorResult, curr: kept[0] }
}

export function getGoodName(key, reverse = false, comp = [], isProduct) {
    if (reverse) {
        // Normal lookup
        return mapERP[key];
    } else {
        // let ze;
        // ze = transformExt(comp);

        // Reversed lookup
        for (let k in mapERP) {
            if (isProduct) {
                if (mapERP[k] === key && comp?.includes(k)) {
                    return k;
                }
            } else {
                if (mapERP[k] === key) {
                    return k;
                }
            }
        }
    }
    return null; // If no match found
}

export function getGoodCanopy(erpName) {
    var rtn;
    switch (erpName) {
        case 'Canopy 03':
            rtn = 'type1';
            break;
        case 'Canopy 01':
            rtn = 'type2';
            break;
        case 'Canopy 04':
            rtn = 'type3';
            break;
        case 'Canopy Nomad':
            rtn = 'nomad';
            break;
        case 'Canopy Billy':
            rtn = 'billy';
            break;
        // case 'canopy.type_03':
        //     rtn = 'type4';
        //     break;
        // default:
        //     rtn = 'type1'
    }
    return rtn;
}
export function getGoodCanopyAK(erpName) {
    var rtn;
    switch (erpName) {
        case 'canopy.type_03':
            rtn = 'type4';
            break;
    }
    return rtn;
}

export function getERPcolorByCode(colors, code) {
    let rtn = {};
    for (let c of colors) {
        if (c.code === code) {
            rtn = c.dataERP;
        }
    }
    return rtn;
}

export function getERPparameterIDByColor(params, colorID) {
    if(!params){return}
    let rtn;
    for (let p of params) {
        if (p.color.id === colorID) {
            rtn = p.id;
        }
    }
    return rtn;
}